import type { HighCpiConfirmationActivityLog } from '../models/high-cpi-confirmation-activity.model';

export class HighCpiConfirmationActivityGenerator {
  public constructor(
    private readonly _surveyId: number,
    private readonly _cpi: number | string,
  ) {}

  public generate(): HighCpiConfirmationActivityLog {
    return {
      eventSource: 'user',
      logMessage: 'CONFIRMED_HIGH_CPI',
      surveyId: this._surveyId,
      metadata: {
        cpi: this._cpi,
      },
    };
  }
}
